import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Lang from "./CompaniesLang";
import "./companies.scss";
import * as actions from "states/appState";

import Company from "components/company/Company";
import Panel from "components/panel/Panel";

export class View extends Component {

    constructor(props) {
        super(props);

        this.state = {
            companies: [],
            selectedCompany: null,
        }
    }

    componentWillMount() {
        this.props.actions.getCompanies();
    }

    selectCompany = async (param, check = false) => {
        if (!this.props.appState.save) {
            const incident = param.props.props;
            var loadedCompanyData;
            try {
                loadedCompanyData = await this.props.actions.getCompanyData(incident);
            } catch (err) {
                // getCompanyData records the load error in Redux; consume the
                // click-handler promise so the browser does not report it as unhandled.
                return err;
            }

            const elems = this.state.companies;
            for (let i = 0; i < elems.length; i++) {
                const elem = elems[i];
                const props = elem.props;
                const data = elem.data;
                const isSelected = props.id === param.props.props.id;
                data.selected = isSelected;
                data.company_data = isSelected ? loadedCompanyData.incident_data : null;
            }

            this.setState({
                companies: elems,
                selectedCompany: param,
            })
        }
    }

    getCompanySelection = (params) => {
        const elems = this.state.companies;
        for (let i = 0; i < elems.length; i++) {
            const elem = elems[i];
            if (elem.props.id === params.id) {
                return elem.data.selected;
            }
        }
        return false;
    }

    floorSelected = (param) => {
        this.props.actions.selectFloor(param.props);

    }

    buildCompanies = (param, key) => {
        return (
            <Company appState={this.props.appState}
                onFloorSelected={this.floorSelected}
                onClick={this.selectCompany} key={key} {...param} />
        )
    }

    componentWillReceiveProps(nextProps) {
        const elems = [];

        for (let i = 0; i < nextProps.appState.companies.length; i++) {
            const eProps = nextProps.appState.companies[i];
            const elem = {
                data: {
                    selected: this.getCompanySelection(eProps),
                    company_data: (this.state.selectedCompany && this.state.selectedCompany.props.props.id === eProps.id) ? nextProps.appState.company_data : null,
                },
                props: eProps,
            }
            elems.push(elem);
        }

        this.setState({
            companies: elems,
        })


    }


    render() {
        return (
            <div className="companies">
                <Panel label={Lang.TITLE} />
                <div className="companies-company">
                    <div className="companies-details">
                        <span>{Lang.COMPANY_ID}</span>
                        <span>{Lang.COMPANY_NAME}</span>
                    </div>
                    {(this.props.appState.errors && this.props.appState.errors.companyData) ?
                        <div className="companies-error">{Lang.ERROR_LOAD}</div>
                        : null}
                    {this.state.companies.map(this.buildCompanies)}
                </div>
            </div>
        );
    }
}

export default connect(
    state => state,
    dispatch => ({
        actions: bindActionCreators(actions, dispatch),
    })
)(View);
